"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorType = void 0;
var ErrorType;
(function (ErrorType) {
    ErrorType["duplicateNamespace"] = "DUPLOCATE_NAMSPACE";
    ErrorType["namespaceNotFound"] = "NAMESPACE_NOT_FOUND";
    ErrorType["duplicateObserver"] = "DUPLICATE_OBSERVER";
    ErrorType["duplicateObservable"] = "DUPLICATE_OBSERVABLE";
    ErrorType["serviceCallBeforeConfig"] = "SERVICE_CALL_BEFORE_CONFIG";
    ErrorType["emptyServiceName"] = "EMPTYSERVICENAME";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/event-bus/errors/error-types.js
// module id = 1185
// module chunks = 8